export default {
  "loginHistory.thead.index": "#序号",
  "loginHistory.thead.userno": "用户编号",
  "loginHistory.thead.clientIp": "客户端IP",
  "loginHistory.thead.header": "请求头",
  "loginHistory.thead.createTime": "创建时间",
  "loginHistory.tooltip.copy.userno": "复制用户编号",
  "loginHistory.tooltip.showUserDetails": "显示用户详细",
};
